import {useState} from 'react';
import {useRouteMatch} from 'react-router-dom';
import {Grid} from 'semantic-ui-react';

import GeneralInfo from 'components/Common/GeneralInfo/GeneralInfo';
import Environments from 'components/WordPress/Environments/Environments';

import styles from './WordPress.module.scss';

const WordPressSite = () => {
  const projectType = 'wordpress';
  let {
    params: {projectName},
  } = useRouteMatch();

  const [project, setProject] = useState();
  const [sites, setSites] = useState([]);

  const messageWithConfs = (
    <>
      You are about to delete the site "<strong>{projectName}</strong>" with all its environments:
      <ul>
        {sites.map(site => (
          <li key={site.hostname}>{site.hostname}</li>
        ))}
      </ul>
      This operation can not be undone. Are you sure that you want to proceed? Please note that:
      <ul>
        <li>It may take some time for the URL(s) to be available for reuse again.</li>
        <li>
          In case you have registered your site for <strong>Web Analytics</strong> and you don't
          need the analytics data anymore, you can request the deletion of the Matomo registration
          via a{' '}
          <a
            className={styles.Link}
            href="https://cern.service-now.com/service-portal?id=sc_cat_item&name=request&fe=web-infrastructure"
            target="_blank"
            rel="noreferrer"
          >
            SNOW ticket
          </a>
          .
        </li>
      </ul>
    </>
  );

  const messageWithoutConfs = (
    <>
      You are about to delete the site "<strong>{projectName}</strong>". This operation can not be
      undone. Are you sure that you want to proceed? Please note that it may take some time for the
      URL(s) to be available for reuse again.
    </>
  );

  return (
    <>
      <Grid centered>
        <Grid.Column className={styles.WordPress}>
          <GeneralInfo
            projectName={projectName}
            projectType={projectType}
            removeProjectMessage={sites.length > 0 ? messageWithConfs : messageWithoutConfs}
            setProject={setProject}
          />
          <Environments
            projectName={projectName}
            project={project}
            onWordPressSites={values => {
              setSites(Object.values(values));
            }}
          />
        </Grid.Column>
      </Grid>
    </>
  );
};

export default WordPressSite;
